<template>
  <div class="distribution__wrapper">
    <div class="distribution__text">
      {{ $t('distribute_started', { prize: currentPrize }) }} <br />
      <span class="free-bets__amount">{{ getFreeBetsAmount }}</span>
      {{ $t('distribute_amount', { prize: currentPrize }) }}
    </div>
    <div class="distribution__close" @click="closePopup">
      <div class="wrapper_btn_close"></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'DistributionFreeBets',
  computed: {
    ...mapGetters(['getFreeBetStarted', 'hasFreeBet']),
    getFreeBetsAmount(): number {
      return this.getFreeBetStarted.data.betCount;
    },
    currentPrize(): string {
      return this.hasFreeBet ? <string>this.$i18n.t('freebet.title') : '';
    }
  },
  methods: {
    closePopup(): void {
      promoApp.store.dispatch(ACTION.SET_MESSAGE_VISIBLE, { visible: false, type: 'freeBetStarted' });
    }
  }
});
</script>

<style lang="scss" scoped>
.distribution__wrapper {
  padding: 10px 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: black;
  border-radius: 24px;
  border: 2px solid #00fc29;
  font-size: 25px;
}

.distribution__text {
  margin-right: 50px;
  line-height: 27px;
  text-align: center;
}

@media (orientation: portrait) {
  .distribution__text {
    font-size: 20px;
  }
}

.free-bets__amount {
  color: #ff0000;
}

.distribution__close {
  cursor: pointer;
  transition: all 0.1s ease;

  &:hover {
    .wrapper_btn_close:after {
      background-color: white;
    }

    .wrapper_btn_close:before {
      background-color: white;
    }
  }
}

.wrapper_btn_close {
  width: 32px;
  height: 32px;
  position: relative;
}

.wrapper_btn_close:after {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  background-color: #b4b4b4;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(45deg);
  transition: all 0.3s ease;
}

.wrapper_btn_close:before {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  background-color: #b4b4b4;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(-45deg);
  transition: all 0.3s ease;
}
</style>